<template>
    <text-input
        :input-label="inputLabel"
        :type="resolveInputType"
        :with-label="withLabel"
        :placeholder="placeholder"
        :input-wrapper-class-list="inputWrapperClassList"
        :input-class-list="inputClassList"
        :has-errors="hasErrors"
        :has-error-icon="hasErrorIcon"
        :value="password"
        @input="handleChange"
    >
        <template slot="label">
            <label class="flex justify-between items-end" v-if="withLabel" :for="id" :class="inputLabelClassList">
                <span>{{ inputLabel }}</span>
                <a v-if="revealPasswordOption" href="#" @click.prevent="revealPassword = !revealPassword" class="text-sm text-blue-400">{{ revealPassword ?
                    'hide' : 'show' }}</a>
            </label>
        </template>

        <slot name="errorMessage">
            <template slot="errorMessage">
            </template>
        </slot>

    </text-input>
</template>

<script>
export default {
    name: "PasswordField",
    props: {
        id: {
            type: String,
            required: false,
            default: () => (Math.random() * 99999).toFixed(0)
        },
        withLabel: {
            type: Boolean,
            required: false,
            default: true,
        },
        inputLabel: {
            type: String,
            default: "Password"
        },
        revealPasswordOption: {
            type: Boolean,
            required: false,
            default: true
        },
        hasErrors: {
            type: Boolean,
            default: false,
            required: false
        },
        hasErrorIcon: {
            type: Boolean,
            default: true,
            required: false
        },
        inputLabelClassList: {
            type: String,
            required: false,
            default: "block text-sm font-medium leading-5 text-gray-700"
        },
        inputWrapperClassList: {
            type: String,
            required: false,
            default: "mt-1 relative rounded-md shadow-sm"
        },
        inputClassList: {
            type: String,
            required: false,
            default: function () {
                let classList = "appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md placeholder-gray-400 focus:outline-none focus:shadow-outline-gray focus:border-gray-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5";
                if (this.hasErrors) {
                    classList += " border-red-300 focus:ring focus:ring-red-400";
                }
                return classList;
            }
        },
        placeholder:{
            type: String,
            required: false,
            default: 'ALongerPasswordIsSecure$25'
        }
    },
    data () {
        return {
            password: "",
            revealPassword: false,
        };
    },
    computed: {
        resolveInputType () {
            if (this.revealPassword == true) {
                return "text";
            }
            return "password";
        }
    },
    methods: {
        handleChange (e) {
            this.password = e;
            this.$emit("input", this.password);
        }
    }
};
</script>

<style scoped>

</style>
